import { useSelector } from 'react-redux';
import FormattedPrice from 'payments-checkout-lib/components/Utilities/FormattedPrice';
import { getDiscountAmount } from '../../state/DiscountCode/discountCodeSlice';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const DiscountAmount = ({
  currencyCode
}) => {
  const discountAmount = useSelector(getDiscountAmount);
  return /*#__PURE__*/_jsx(Text, {
    typography: "body-125",
    children: /*#__PURE__*/_jsx(FormattedPrice, {
      testId: "discount-amount",
      price: -discountAmount.discountedValue,
      currencyCode: currencyCode
    })
  });
};
export default DiscountAmount;